<template>
  <div
    class="box-logo flex align-center justify-space-between"
    :class="{ 'nav-collapsed': collapseNav, [mode]: true }"
  >
    <div>
      <img
        class="image-logo"
        src="@/assets/images/absent-logo-transparent.png"
        alt="logo"
        @click="logoLink"
      />
    </div>
    <div class="d-lg-none" @click="$emit('close-nav')">
      <span class="mdi mdi-window-close close-btn"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Logo",
  props: ["collapseNav", "mode"],
  data() {
    return {};
  },
  computed: {
    roleId() {
      return this.$store.getters.user.roleId;
    },
  },
  methods: {
    collapseNavToggle() {
      this.$emit("collapse-nav-toggle");
    },

    logoLink() {
      const currentRoute = this.$router.currentRoute;

      if (this.roleId === 2) {
        if (currentRoute.path !== "/dashboard") {
          this.$router.push("/dashboard");
        }
        return;
      }

      if (this.$store.getters.termsAndConditionsAccepted) {
        if (currentRoute.path !== "/my-presence") {
          this.$router.push("/my-presence");
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/_variables";
.close-btn {
  cursor: pointer;
}
.close-btn:hover {
  color: $logo-color-lightred;
}
</style>
<style lang="scss">
@import "../assets/scss/_variables";
@import "../assets/scss/_mixins";

.box-logo {
  height: 60px;
  padding: 0 20px;
  box-sizing: border-box;
  font-size: 20px;
  font-weight: bold;
  position: relative;
  @include text-bordered-shadow();

  .letter-logo {
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: $text-color;
    color: $text-color-accent;
    border-radius: 5px;
    margin-right: 10px;
    font-weight: bolder;
    font-size: 20px;
  }

  .image-logo {
    max-height: 35px;

    cursor: pointer;
  }

  .app-name {
    cursor: pointer;
  }

  .collapse-nav {
    position: absolute;
    top: 50%;
    left: 10px;
    height: 30px;
    width: 30px;
    margin-top: -15px;
    opacity: 0;
    box-shadow: 0px 0px 20px 10px $background-color;
    cursor: pointer;
    border: 1px solid $text-color-accent;
    border-radius: 50%;
    color: $text-color-accent;
    outline: none;
    background: $background-color;
    transition: all 0.5s;
  }

  &:hover {
    .collapse-nav {
      opacity: 1;
      left: 20px;
    }
  }

  &.nav-collapsed {
    .app-name {
      display: none;
    }
  }

  &.horizontal {
    height: 100%;

    .collapse-nav {
      display: none;
    }
  }
}

@media (max-width: 1240px) {
  .box-logo {
    .collapse-nav {
      display: none;
    }

    &.horizontal {
      padding: 0 10px;

      .app-name {
        display: none;
      }
    }
  }
}
</style>
